import { render } from "./AFooterSoc.vue?vue&type=template&id=5578ff3a"
import script from "./AFooterSoc.vue?vue&type=script&lang=ts"
export * from "./AFooterSoc.vue?vue&type=script&lang=ts"

import "./AFooterSoc.vue?vue&type=style&index=0&id=5578ff3a&lang=postcss"
script.render = render

export default script